const constructAttemptState = (currentAttempt, answer) => {
  const { question, correct } = answer
  const updatedAttempt = Object.assign({}, currentAttempt, {
    correct: correct ? currentAttempt.correct + 1 : currentAttempt.correct,
    incorrect: !correct
      ? currentAttempt.incorrect + 1
      : currentAttempt.incorrect,
    completed: question === currentAttempt.quiz_length,
  })

  return updatedAttempt
}

export const createAnswerHandler =
  (quizId, quizAttempt, currentQuestion, persistAnswer, sendAnswer) =>
  (data) => {
    const { answer, correct, order } = data
    const question = currentQuestion + 1
    const newAnswer = {
      question,
      answer: parseInt(answer, 10),
      order,
      result: correct ? 'correct' : 'incorrect',
    }

    const updatedAttempt = constructAttemptState(quizAttempt, {
      question,
      correct,
    })

    persistAnswer(newAnswer, updatedAttempt)
    sendAnswer(quizId, newAnswer, updatedAttempt)
  }
